import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IContact, IContactInput } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class ContactApiService {
  abstract getContact(id?: string | '', resetCache?:boolean ): Observable<IContact>;


  abstract updateContact(contact: IContactInput): Observable<IContact>;

}
